// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/AkayaTelivigala-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/AkayaTelivigala-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-pri: #618f61;
  --color-sec: #badbba;
  --color-tri: #1f2c1f;
  --color-tri-filter: brightness(0) saturate(100%) invert(7%) sepia(5%)
    saturate(6176%) hue-rotate(71deg) brightness(91%) contrast(79%);
  --size-pri: clamp(0.8rem, 0.8rem + 0.4vw, 2rem);
  --radius-pri: 10px;
  font-family:
    "Akaya Telivigala",
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
  letter-spacing: 0.1em;
  line-height: 1.3em;
}

@font-face {
  font-family: "Akaya";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

body {
  /* background: linear-gradient(
    170deg,
    var(--color-pri) 10%,
    white 30% 60%,
    var(--color-pri) 75%
  ); */
  color: var(--color-tri);
}

h1 {
  font-size: calc(4 * var(--size-pri));
  font-weight: 900;
  text-wrap: balance;
  line-height: 1em;
  text-shadow:
    1px 1px var(--color-tri),
    1px -1px var(--color-tri),
    -1px 1px var(--color-tri),
    -1px -1px var(--color-tri);
}

h2 {
  font-size: calc(2.5 * var(--size-pri));
  font-weight: 600;
  text-wrap: balance;
}

h3 {
  font-size: calc(2 * var(--size-pri));
  font-weight: 400;
}

img {
  max-height: 500px;
}

img[src\$=".svg"] {
  filter: var(--color-tri-filter);
}

.container {
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  align-items: center;
  padding: calc(2 * var(--size-pri));
  padding-bottom: 0;
  gap: calc(5 * var(--size-pri));
}

header,
main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(2 * var(--size-pri));
}

main {
  width: 100%;
}

.profile-img {
  position: relative;

  > h1 {
    position: absolute;
    bottom: var(--size-pri);
    left: var(--size-pri);
    color: var(--color-sec);
  }
}

.icons {
  * {
    width: min(7vw, 7vh);
    display: inline-block;
  }
}

.project-cards {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(300px, 30%), 1fr));
  grid-auto-rows: auto;
  gap: calc(2 * var(--size-pri));
}

.project-card {
  box-shadow: 0.1em 0.1em 1em 0.1em var(--color-tri);
  border-radius: var(--radius-pri);
  display: grid;
  grid-template-rows: auto 0.5fr 1fr 1fr;

  .project-screenshot {
    object-fit: contain;
    border-radius: var(--radius-pri) var(--radius-pri) 0 0;
  }

  > *:not(.project-screenshot) {
    padding: var(--size-pri);
  }

  .project-menu {
    display: flex;
    justify-content: space-between;
  }

  .project-icons {
    width: 30%;
    display: flex;
    justify-content: flex-end;
    * {
      display: inline-block;
      height: 100%;
    }
  }

  .projects-topics {
  }

  span {
    display: inline-block;
    border-radius: 0 var(--radius-pri) var(--radius-pri) 0;
    box-shadow: 0.1em 0em 0.2em 0.1em var(--color-tri);
    padding: 0.3em;
    margin-right: var(--size-pri);
    margin-bottom: var(--size-pri);
  }
}

footer {
  display: grid;
  justify-items: center;
  gap: calc(2 * var(--size-pri));

  > p {
    padding: calc(2 * var(--size-pri));
  }

  > img {
    min-width: 100vw;
    object-fit: cover;
  }
}

@media (min-width: 800px) {
  header {
    margin-top: calc(6 * var(--size-pri));
    display: block;
    position: relative;

    h2,
    p {
      padding: var(--size-pri);
    }

    p {
      margin-bottom: min(5vw, 5vh);
    }

    .icons {
      position: absolute;
      right: min(1vw, 1vh);
      bottom: min(1vw, 1vh);
    }
  }

  header,
  footer {
    padding: var(--size-pri);
  }

  header,
  footer {
    box-shadow: 0.1em 0.1em 1em 0.1em var(--color-tri);
    border-radius: var(--radius-pri);
  }

  .profile-img {
    width: 33%;
    float: left;
    margin-right: var(--size-pri);

    img {
      transform-origin: bottom right;
      transform: scale(1.6);
      position: relative;
    }

    h1 {
      top: -40%;
      left: 80%;
      z-index: 1;
      width: max-content;
    }
  }

  footer {
    grid-template-rows: repeat(3, auto);
    grid-template-columns: repeat(2, auto);
    margin-bottom: calc(2 * var(--size-pri));
    padding: calc(2 * var(--size-pri));

    > img {
      grid-area: 1 / 2 / -1 / -1;
      border-radius: var(--radius-pri);
      min-width: auto;
      height: 100%;
    }
  }
}

@media (min-width: 1200px) {
  .profile-img {
    width: 40%;
    float: left;
    margin-right: var(--size-pri);

    img {
      transform-origin: right;
      transform: scale(1.2);
    }

    h1 {
      top: auto;
      left: auto;
      bottom: 0;
      min-width: fit-content;
    }
  }
}

@media (min-width: 2000px) {
  .profile-img {
    width: 20%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/main-style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB;mEACiE;EACjE,+CAA+C;EAC/C,kBAAkB;EAClB;;;;;;;;;;;;cAYY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;;0DAE6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;;;;;MAKI;EACJ,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB;;;;8BAI4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;;EAElB;IACE,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sEAAsE;EACtE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,kDAAkD;EAClD,gCAAgC;EAChC,aAAa;EACb,sCAAsC;;EAEtC;IACE,mBAAmB;IACnB,sDAAsD;EACxD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB;MACE,qBAAqB;MACrB,YAAY;IACd;EACF;;EAEA;EACA;;EAEA;IACE,qBAAqB;IACrB,sDAAsD;IACtD,kDAAkD;IAClD,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;;EAE9B;IACE,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,cAAc;IACd,kBAAkB;;IAElB;;MAEE,wBAAwB;IAC1B;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,kBAAkB;MAClB,oBAAoB;MACpB,qBAAqB;IACvB;EACF;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,kDAAkD;IAClD,gCAAgC;EAClC;;EAEA;IACE,UAAU;IACV,WAAW;IACX,6BAA6B;;IAE7B;MACE,8BAA8B;MAC9B,qBAAqB;MACrB,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,SAAS;MACT,UAAU;MACV,kBAAkB;IACpB;EACF;;EAEA;IACE,mCAAmC;IACnC,sCAAsC;IACtC,wCAAwC;IACxC,kCAAkC;;IAElC;MACE,0BAA0B;MAC1B,gCAAgC;MAChC,eAAe;MACf,YAAY;IACd;EACF;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,6BAA6B;;IAE7B;MACE,uBAAuB;MACvB,qBAAqB;IACvB;;IAEA;MACE,SAAS;MACT,UAAU;MACV,SAAS;MACT,sBAAsB;IACxB;EACF;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[":root {\n  --color-pri: #618f61;\n  --color-sec: #badbba;\n  --color-tri: #1f2c1f;\n  --color-tri-filter: brightness(0) saturate(100%) invert(7%) sepia(5%)\n    saturate(6176%) hue-rotate(71deg) brightness(91%) contrast(79%);\n  --size-pri: clamp(0.8rem, 0.8rem + 0.4vw, 2rem);\n  --radius-pri: 10px;\n  font-family:\n    \"Akaya Telivigala\",\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    \"Open Sans\",\n    \"Helvetica Neue\",\n    sans-serif;\n  letter-spacing: 0.1em;\n  line-height: 1.3em;\n}\n\n@font-face {\n  font-family: \"Akaya\";\n  src:\n    url(\"../fonts/AkayaTelivigala-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/AkayaTelivigala-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\nbody {\n  /* background: linear-gradient(\n    170deg,\n    var(--color-pri) 10%,\n    white 30% 60%,\n    var(--color-pri) 75%\n  ); */\n  color: var(--color-tri);\n}\n\nh1 {\n  font-size: calc(4 * var(--size-pri));\n  font-weight: 900;\n  text-wrap: balance;\n  line-height: 1em;\n  text-shadow:\n    1px 1px var(--color-tri),\n    1px -1px var(--color-tri),\n    -1px 1px var(--color-tri),\n    -1px -1px var(--color-tri);\n}\n\nh2 {\n  font-size: calc(2.5 * var(--size-pri));\n  font-weight: 600;\n  text-wrap: balance;\n}\n\nh3 {\n  font-size: calc(2 * var(--size-pri));\n  font-weight: 400;\n}\n\nimg {\n  max-height: 500px;\n}\n\nimg[src$=\".svg\"] {\n  filter: var(--color-tri-filter);\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  justify-items: flex-start;\n  align-items: center;\n  padding: calc(2 * var(--size-pri));\n  padding-bottom: 0;\n  gap: calc(5 * var(--size-pri));\n}\n\nheader,\nmain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: calc(2 * var(--size-pri));\n}\n\nmain {\n  width: 100%;\n}\n\n.profile-img {\n  position: relative;\n\n  > h1 {\n    position: absolute;\n    bottom: var(--size-pri);\n    left: var(--size-pri);\n    color: var(--color-sec);\n  }\n}\n\n.icons {\n  * {\n    width: min(7vw, 7vh);\n    display: inline-block;\n  }\n}\n\n.project-cards {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(max(300px, 30%), 1fr));\n  grid-auto-rows: auto;\n  gap: calc(2 * var(--size-pri));\n}\n\n.project-card {\n  box-shadow: 0.1em 0.1em 1em 0.1em var(--color-tri);\n  border-radius: var(--radius-pri);\n  display: grid;\n  grid-template-rows: auto 0.5fr 1fr 1fr;\n\n  .project-screenshot {\n    object-fit: contain;\n    border-radius: var(--radius-pri) var(--radius-pri) 0 0;\n  }\n\n  > *:not(.project-screenshot) {\n    padding: var(--size-pri);\n  }\n\n  .project-menu {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .project-icons {\n    width: 30%;\n    display: flex;\n    justify-content: flex-end;\n    * {\n      display: inline-block;\n      height: 100%;\n    }\n  }\n\n  .projects-topics {\n  }\n\n  span {\n    display: inline-block;\n    border-radius: 0 var(--radius-pri) var(--radius-pri) 0;\n    box-shadow: 0.1em 0em 0.2em 0.1em var(--color-tri);\n    padding: 0.3em;\n    margin-right: var(--size-pri);\n    margin-bottom: var(--size-pri);\n  }\n}\n\nfooter {\n  display: grid;\n  justify-items: center;\n  gap: calc(2 * var(--size-pri));\n\n  > p {\n    padding: calc(2 * var(--size-pri));\n  }\n\n  > img {\n    min-width: 100vw;\n    object-fit: cover;\n  }\n}\n\n@media (min-width: 800px) {\n  header {\n    margin-top: calc(6 * var(--size-pri));\n    display: block;\n    position: relative;\n\n    h2,\n    p {\n      padding: var(--size-pri);\n    }\n\n    p {\n      margin-bottom: min(5vw, 5vh);\n    }\n\n    .icons {\n      position: absolute;\n      right: min(1vw, 1vh);\n      bottom: min(1vw, 1vh);\n    }\n  }\n\n  header,\n  footer {\n    padding: var(--size-pri);\n  }\n\n  header,\n  footer {\n    box-shadow: 0.1em 0.1em 1em 0.1em var(--color-tri);\n    border-radius: var(--radius-pri);\n  }\n\n  .profile-img {\n    width: 33%;\n    float: left;\n    margin-right: var(--size-pri);\n\n    img {\n      transform-origin: bottom right;\n      transform: scale(1.6);\n      position: relative;\n    }\n\n    h1 {\n      top: -40%;\n      left: 80%;\n      z-index: 1;\n      width: max-content;\n    }\n  }\n\n  footer {\n    grid-template-rows: repeat(3, auto);\n    grid-template-columns: repeat(2, auto);\n    margin-bottom: calc(2 * var(--size-pri));\n    padding: calc(2 * var(--size-pri));\n\n    > img {\n      grid-area: 1 / 2 / -1 / -1;\n      border-radius: var(--radius-pri);\n      min-width: auto;\n      height: 100%;\n    }\n  }\n}\n\n@media (min-width: 1200px) {\n  .profile-img {\n    width: 40%;\n    float: left;\n    margin-right: var(--size-pri);\n\n    img {\n      transform-origin: right;\n      transform: scale(1.2);\n    }\n\n    h1 {\n      top: auto;\n      left: auto;\n      bottom: 0;\n      min-width: fit-content;\n    }\n  }\n}\n\n@media (min-width: 2000px) {\n  .profile-img {\n    width: 20%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
